export enum feedbackActionTypes {
  FEEDBACK_DATA_LOADING = 'FEEDBACK_DATA_LOADING',
  SET_FEEDBACK_DATA = 'SET_FEEDBACK_DATA',
}
